import React from "react";
import { STORE_STATUS } from "../../../commons/constants/store";
import styles from "./store-card.module.scss";
interface props {
  storeId: string;
  status: STORE_STATUS;
  handleOffStore: (storeId: string) => void;
  handleOpenStore: (storeId: string) => void;
  handleCloseStore: (storeId: string) => void;
  handleToggleThreshold: (storeId: string, auto: boolean) => void;
  handleToggleTerminal: (storeId: string, terminal: boolean) => void;
  isAutoThresholdEnabled?: boolean;
  isTerminalEnabled?: boolean;
}
const PopupStatus: React.FC<props> = ({ status, storeId, handleCloseStore, handleOffStore, handleOpenStore }) => {
  if (status === STORE_STATUS.LIVE) {
    return (
      <div className={styles.btnAction}>
        <p
          onClick={e => {
            e.stopPropagation();
            handleOffStore(storeId);
          }}
        >
          Offline
        </p>
        <p
          onClick={e => {
            e.stopPropagation();
            handleCloseStore(storeId);
          }}
        >
          Close
        </p>
      </div>
    );
  } else if (status === STORE_STATUS.SUSPENDED) {
    return (
      <div className={styles.btnAction}>
        <p
          onClick={e => {
            e.stopPropagation();
            handleOpenStore(storeId);
          }}
        >
          Open
        </p>
        <p
          onClick={e => {
            e.stopPropagation();
            handleCloseStore(storeId);
          }}
        >
          Close
        </p>
      </div>
    );
  } else if (status === STORE_STATUS.CLOSED) {
    return (
      <div className={styles.btnAction}>
        <p
          onClick={e => {
            e.stopPropagation();
            handleOpenStore(storeId);
          }}
        >
          Open
        </p>
        <p
          onClick={e => {
            e.stopPropagation();
            handleOffStore(storeId);
          }}
        >
          Offline
        </p>
      </div>
    );
  } else {
    return (
      <div className={styles.btnAction}>
        <p
          onClick={e => {
            e.stopPropagation();
            handleOpenStore(storeId);
          }}
        >
          Open
        </p>
        <p
          onClick={e => {
            e.stopPropagation();
            handleCloseStore(storeId);
          }}
        >
          Close
        </p>
      </div>
    );
  }
};

export default PopupStatus;
